export default "__VITE_ASSET__BXO2Mkae__"